import React, { useState, useEffect } from "react";
import HomeLayout from "../../Components/Landing/HomeLayout";
import "./commonLayout.css";
import utils from "../../Utils";
import Logo from "../../Assets/Images/logo.svg";
import { useTranslation } from "react-i18next";
import TermsCondition from "../../Components/TermsCondition/TermsCondition";
import Widgets from "../../Widgets";
import { useNavigate, Outlet } from "react-router";
import Select, { components } from "react-select";
import utilFunctions from "../../Utils/utilFunctions";
import authService from "../../Services/authService";

const Landing = () => {
  const nav = useNavigate();
  const { t, i18n } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    let session = authService.getToken();
    let isDoctorLogin = authService.getIsDoctorLogin();
    if (session && isDoctorLogin !== "true") {
      nav(utils.strings.navigation.dashboard);
    } else if (session && isDoctorLogin === "true") {
      // nav(utils.strings.navigation.doctorDashboard);
    }
  }, []);


  const changeLanguage = (lng) => {
    utilFunctions.changeLanguage(i18n, lng);
  };

  function renderView() {
    return <iframe src={utils.config.tAndC} className="w-full h-[70vh] overflow-hidden" />;
  }
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <div>{props.children}</div>
      </components.SingleValue>
    );
  };
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div>{props.label}</div>
        <div className="sub-label">{props.data.subTitle}</div>
      </components.Option>
    );
  };

  return (
    <>
      {showPopup ? (
        <Widgets.AppDialog
          widthType={utils.constants.dialogWidthType.big}
          setVisibility={(e) => {
            setShowPopup(e);
          }}
          dialogTitle={t("termsConditions")}
          view={renderView()}
        />
      ) : null}
      <div className="flex px-4  pb-0 md:p-0">
        <div className="w-[49%] h-auto p-8 pb-0 hidden md:block">
          <HomeLayout />
        </div>
        <div className="w-full h-[100vh] md:w-2/4 background_image flex flex-col justify-between p-8 welcome-layout-resp">
          <div>
            <div className="flex justify-between items-center">
              <img className="w-[16rem] welcome-logo-resp" src={Logo} alt="FV@Home" />
              <div className="pl-2">
                <Select
                  isSearchable={false}
                  styles={utils.appStyles.smallDropDown}
                  className="language-select"
                  components={{ Option, SingleValue }}
                  options={utils.constants.languageOptions}
                  value={utils.constants.sortedLanguageOptions.find((option) => option.value === i18n.language)}
                  defaultValue={utils.constants.sortedLanguageOptions.find((option) => option.value === "en")}
                  onChange={(option) => changeLanguage(option.value)}
                />
              </div>
            </div>
          </div>
          <div>
            <Outlet />
          </div>
          <div>
            <TermsCondition setPopup={setShowPopup} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Landing;
